import React, { useContext, useEffect, useState } from 'react';
import BidBoxContext from '../../../../../BidBoxContainer/BidBoxContext';
import PendingBidBoxFooterContext from '../../../PendingBidBoxFooterContainer/PendingBidBoxFooterContext';
import StyledOfferStatusMessage from './Styles';
import useNegotiationOfferLabels from '../../../../../../../_shared/hooks/trade/useNegotiationOfferLabels';

const OfferStatusMessage = ({ tradeContext }) => {
  const [message, setMessage] = useState('');
  const { tradeDetails } = useContext(BidBoxContext);
  const { isGreyOut } = tradeDetails;
  const { negotiationState } = useContext(PendingBidBoxFooterContext);

  const [offerTitle] = useNegotiationOfferLabels(
    negotiationState,
    tradeContext,
    isGreyOut
  );

  useEffect(() => {
    if (tradeDetails && negotiationState) {
      setMessage(offerTitle);
    }
  }, [tradeDetails, negotiationState, offerTitle]);

  return <StyledOfferStatusMessage>{message}</StyledOfferStatusMessage>;
};

export default OfferStatusMessage;
